import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element, ...rest }) => {
  const userCreds = localStorage.getItem('userCreds');

  return userCreds ? element : <Navigate to="/" />;
};

export default ProtectedRoute;
